<div class="tw-size-9 tw-rounded-md gray-background-color d-flex justify-content-center align-items-center">
  <img *ngIf="image" src={{image}} alt="">
  <i *ngIf="!image" class="icon feather icon-settings"></i>
</div>